export default __webpack_public_path__ + "static/media/Aura-Egg__54.9a3d0ad0.png";